import { useRef } from 'react'
import { useOutsideClick } from 'hooks'
import * as S from './FullscreenModal.styled'
import { Modal } from 'components/global/Modal/Modal'

export const FullscreenModal = ({
  children,
  show: [show, setShow] = [false, () => {}],
  hideClose,
  $zIndex = 0,
  ...props
}) => {
  const modal = useRef(null)
  useOutsideClick(modal, show, () => !hideClose && setShow(false), 'mousedown')

  return (
    <S.Wrapper $zIndex={$zIndex} show={show} backdrop {...props}>
      <S.RefWrapper ref={modal} show={show}>
        <Modal
          position="relative"
          bottom={show ? '0' : '12px'}
          show={[show, setShow]}
          hideClose={hideClose}
        >
          {children}
        </Modal>
      </S.RefWrapper>
    </S.Wrapper>
  )
}

export default FullscreenModal
